<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          基于物联网的设备管理平台
        </div>
        <div class="txt">
          IoT-based device management platform
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>物联网智能集中器在配网自动化中的应用研究项目成果由国网上海市电力公司浦东供电公司于2018年11月在浦东电站实践应用。
            是一种基于物联网的UPS、DTU状态智能集中器，利用信息化手段采集并获取变配电站的UPS不间断电源设备、DTU设备的运行状态及故障信息，
            感知配网自动化运行状态。并在此基础上，该项目实现了利用移动移动终端与互联网等技术为配网设备检修单位提供快速高效的故障检索、
            故障定位服务，该设备提供远程重启唤醒的功能以应对单纯依靠重新启动设备就能解决的简单故障。</p>
          <p>实践证明，该项目的应用和推广不仅能大量提高配网自动化的智能化水平，还可以大幅度减轻设备运维人员的工作量。
            真正实现了利用移动移动终端与互联网等技术为配网设备检修单位提供快速高效的故障检索、故障定位服务，及远程重启唤醒的功能。</p>
        </div> 
      </div>
      <div>
        <div class="title">产品图片</div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/pic13.png" alt="">
          </div>
          <div class="list_one">
            <img src="../assets/pic14.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one">
            <img src="../assets/pic15.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/pic16.png" alt="">
          </div>
          <div class="list_one">
            <img src="../assets/pic17.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one">
            <img src="../assets/pic18.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one">
            <img src="../assets/pic19.png" alt="">
          </div>
        </div> 
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 350px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one .one img {
  width: 1000px;
  height: 450px;
}
.img_one img {
  width: 430px;
  height: 380px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}


.detail_foot {
  margin-top: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail5.vue